export default {"src":"/_next/static/media/about-benefit-1.9731f424.svg","height":213,"width":234,"blurWidth":0,"blurHeight":0};